import { z } from 'zod';

// The player site and the dashboard run under a content security policy without eval. Zod 4 would otherwise try
// new Function() when its object schemas are made (the policy blocks it and reports a violation), so each app
// imports this first, before any schema is made.
z.config({ jitless: true });
